import React from 'react'
import {strVal} from '../../../modules/Utils'

const UpperCaseCell = ({value}) => strVal({value}, 'value').toUpperCase()
export default UpperCaseCell
